// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__1QEOh","field":"styles_field__3wfTV","label":"styles_label__1WGGz","button":"styles_button__13-M0"};